import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthFrontLockProvider } from './context/useAuthFrontContext';


const loadConfigs = async () => {

  

  const root = ReactDOM.createRoot(
    document.getElementById('auth-spa-root') as HTMLElement
  );

  if (process.env.NODE_ENV === "development") {
    (window as any).authFrontConfig.encodedIdpSettings = process.env.REACT_APP_AUTH0_TENANT_CONFIG;
  }

  root.render(
    <React.StrictMode>
      <AuthFrontLockProvider>
        <App />
      </AuthFrontLockProvider>
    </React.StrictMode>
  );
}

loadConfigs();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
